export const siteConfig = {
  name: "ClinicSuite360",
  tagline: "Run, Grow & Automate Your Clinic",
  description:
    "The all-in-one platform for Indian clinics: appointments, EMR, billing, a branded website, WhatsApp automation, and AI -- built for solo practitioners, multi-doctor clinics, and small chains.",
  // Root domain used for tenant subdomains -- provisional, see DEVELOPMENT_PLAN.md.
  rootDomain: "clinicsuite360.com",
  // Who makes ClinicSuite360, credited in the footer. The footer links the
  // name only when a URL is set here, so it can never render a dead link.
  company: {
    name: "Frequent Solutions",
    url: "https://frequentsolutions.com",
  },
};

// Features/Pricing/FAQ live as sections on the home page (not separate
// pages) -- their nav entries are anchors. "Request a demo" points at the
// Book a demo section (which has phone/email) since there's no standalone
// contact page anymore. Reused as-is in the footer's single-line nav row.
export const marketingNavLinks = [
  { href: "/", label: "Home" },
  { href: "/#features", label: "Features" },
  { href: "/#pricing", label: "Pricing" },
  { href: "/blog", label: "Blog" },
  { href: "/about", label: "About" },
  { href: "/#demo", label: "Request a demo" },
];

export const legalLinks = [
  { href: "/terms", label: "Terms & Conditions" },
  { href: "/privacy", label: "Privacy Policy" },
];

export function formatInr(amountInRupees: number): string {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amountInRupees);
}

export function formatPaise(paise: number): string {
  return formatInr(paise / 100);
}
